export default __webpack_public_path__ + "static/media/wi-fog.7c3d1014.svg";